







import TabItem from './tab-item.vue';
import { computed, defineComponent } from '@vue/composition-api';
import { useRoute } from '@/hooks/use-route';
import { biClick } from '@tencent/fit-bi-sdk';
import { resolveDefaultHeaderTab } from '@/config/page-tab';

export default defineComponent({
  name: 'MyCouponTap',
  components: {
    TabItem,
  },
  props: {
    /** 自动扣减券数量 */
    autoCount: {
      type: Number,
      default: 0,
    },
    /** 手动启用券数量 */
    manualCount: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { router } = useRoute();
    /** 入口展示的优惠券总数 = 自动扣减券 + 手动启用券 */
    const totalCount = computed(() => props.autoCount + props.manualCount);
    const biExt = computed(() => ({
      fcount: `${totalCount.value}`,
    }));
    return {
      totalCount,
      biExt,
      clickTab() {
        biClick('my-coupon-tab.click|我的优惠券点击', biExt.value);
        router.push({
          name: resolveDefaultHeaderTab(props.autoCount, props.manualCount),
        });
      },
    };
  },
});
